/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const UPDATE_TIME_INTERVAL = 1000;
export const RESIZE_CHECK_INTERVAL = 250;
